import React from "react";
import PageNotification from "../../../ui/PageNotification/PageNotification";

const TeaserPageNotifications = ({ notifications }) => {
  return (
    <div className="page-notifications">
      <div className="content-body">
        {notifications.cnt.map(notification => (
          <PageNotification
            notification={notification}
            message={"Необходимо увеличить количество анонсов"}
            key={notification.group}
          />
        ))}
      </div>
    </div>
  );
};

export default TeaserPageNotifications;
